import { render, staticRenderFns } from "./MonthlyShiftCalendar.vue?vue&type=template&id=53fd2aea&scoped=true&lang=pug"
import script from "./MonthlyShiftCalendar.vue?vue&type=script&lang=js"
export * from "./MonthlyShiftCalendar.vue?vue&type=script&lang=js"
import style0 from "./MonthlyShiftCalendar.vue?vue&type=style&index=0&id=53fd2aea&prod&scoped=true&lang=stylus"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53fd2aea",
  null
  
)

export default component.exports